/* eslint-disable indent */
import React from "react";
import { getDolarFallback } from "../../../utils/exchangeRateService";
import styles from "../stylesERv2.module.scss";

export const EBITDAResultadoTable = ({
  modoCombinado,
  monthsToShow,
  formatCurrency,
  porcentajeSobreFacturacion,
  publicidadMensualesCombinados,
  hardwareMensualesCombinados,
  gestionMensualesCombinados,
  btlMensualesCombinados,
  costosVariablesMensualesCombinados,
  costosFijosMensualesCombinados,
  valoresMensuales,
  ingresosHardwareMensual,
  ingresosGestionContenidosMensual,
  ingresosBTLMensual,
  camposCostosFijos,
  getCostoFijoValor,
  rrhhMensualConBeneficios,
  totalCostosMes,
  margenFinal,
  costosFijosYTD,
  sumarCostosFijosMes,
  valoresMensualesComisionAgencia,
  valoresMensualesComisiones,
  valoresMensualesComisionComercial,
  conceptosManuales,
  getValueForMonth,
  compraHardwareMensual,
  instalacionMensual,
  materialesMensual,
  otrosCostosMensual,
  getCostoGestionValue,
  comisionEdificiosBTLMensual,
  otrosCostosBTLMensual,
  ebitCollapsed,
  setEbitCollapsed,
  depreciacionMensualesCombinados,
  depreciacionMensual,
  amortizacionMensualesCombinados,
  amortizacionMensual,
  meses,
  resultadoCollapsed,
  setResultadoCollapsed,
  interesesMensualesUSD,
  impuestosMensualesUSD,
  verChileYPeru,
  verEnDolares,
  pais,
  moneda,
  dolarMensual,
  dolarMensualPeru,
  dolarFallback,
  setIsInteresesModalOpen,
  verUltimos12Meses,
  ebitdaMensualWindowed,
  facturacionMensualWindowed,
  costosVariablesMensualWindowed,
  costosFijosMensualWindowed,
}) => (
  <>
    {/* === EBITDA === */}
    <tr className={styles.ebitdaRow}>
      <td className={styles.conceptCellMargen}>EBITDA</td>
      {Array(12)
        .fill(0)
        .map((_, i) => {
          if (i >= monthsToShow) return <td key={i}>-</td>;
          // En modo combinado usar valores FIJOS ya en USD
          if (modoCombinado) {
            const facturacionMes =
              (publicidadMensualesCombinados[i] || 0) +
              (hardwareMensualesCombinados[i] || 0) +
              (gestionMensualesCombinados[i] || 0) +
              (btlMensualesCombinados[i] || 0);
            const costosVar = costosVariablesMensualesCombinados[i] || 0;
            const costosFijos = costosFijosMensualesCombinados[i] || 0;
            const ebitda = facturacionMes - costosVar - costosFijos;
            return (
              <td key={i} className="text-end">
                <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i, null, true)}</div>
              </td>
            );
          }
          // Modo ventana: usar array pre-computado
          if (verUltimos12Meses) {
            const ebitda = ebitdaMensualWindowed[i] || 0;
            return (
              <td key={i} className="text-end">
                <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i)}</div>
              </td>
            );
          }
          // Modo normal
          const facturacionMes =
            (valoresMensuales[i] || 0) +
            (ingresosHardwareMensual[i] || 0) +
            (ingresosGestionContenidosMensual[i] || 0) +
            (ingresosBTLMensual[i] || 0);
          const costosFijosMes =
            camposCostosFijos.reduce((sum, campo) => sum + (getCostoFijoValor(campo, i) ?? 0), 0) +
            (i < monthsToShow ? rrhhMensualConBeneficios[i] : 0);
          const ebitda = facturacionMes - totalCostosMes(i) - costosFijosMes;
          return (
            <td key={i} className="text-end">
              <div className={ebitda < 0 ? styles.marginNegative : ""}>{formatCurrency(ebitda, i)}</div>
            </td>
          );
        })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado) {
            const totalFact =
              publicidadMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const totalCV = costosVariablesMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const totalCF = costosFijosMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const ebitdaComb = totalFact - totalCV - totalCF;
            const pct = totalFact > 0 ? ((ebitdaComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitdaComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaComb, null, null, true)} | {pct}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados
          if (verUltimos12Meses) {
            const ebitdaYTD = ebitdaMensualWindowed.reduce((a, b) => a + b, 0);
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((ebitdaYTD / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitdaYTD < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitdaYTD, null, ebitdaMensualWindowed)} | {pct}
              </div>
            );
          }
          return (
            <div className={margenFinal - costosFijosYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(
                margenFinal - costosFijosYTD,
                null,
                Array.from({ length: 12 }, (_, i) => {
                  if (i >= monthsToShow) return 0;
                  const facturado =
                    (valoresMensuales[i] || 0) +
                    (ingresosHardwareMensual[i] || 0) +
                    (ingresosGestionContenidosMensual[i] || 0) +
                    (ingresosBTLMensual[i] || 0);
                  const costosFijos = sumarCostosFijosMes(i);
                  return facturado - totalCostosMes(i) - costosFijos;
                })
              )}{" "}
              | {porcentajeSobreFacturacion(margenFinal - costosFijosYTD)}
            </div>
          );
        })()}
      </td>
    </tr>
    {/* Depreciación y Amortización (colapsables desde EBIT) */}
    {!ebitCollapsed && (
      <>
        <tr>
          <td className={styles.conceptCell}>Depreciación</td>
          {meses.map((_, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow
                ? modoCombinado && depreciacionMensualesCombinados
                  ? formatCurrency(depreciacionMensualesCombinados[i], null, null, true)
                  : formatCurrency(depreciacionMensual[i], i)
                : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {modoCombinado && depreciacionMensualesCombinados
              ? formatCurrency(
                  depreciacionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                  null,
                  null,
                  true
                )
              : formatCurrency(
                  depreciacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                  null,
                  depreciacionMensual
                )}
          </td>
        </tr>
        <tr>
          <td className={styles.conceptCell}>Amortización</td>
          {meses.map((_, i) => (
            <td key={i} className="text-end">
              {i < monthsToShow
                ? modoCombinado && amortizacionMensualesCombinados
                  ? formatCurrency(amortizacionMensualesCombinados[i], null, null, true)
                  : formatCurrency(amortizacionMensual[i], i)
                : "-"}
            </td>
          ))}
          <td className={styles.totalCell}>
            {modoCombinado && amortizacionMensualesCombinados
              ? formatCurrency(
                  amortizacionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                  null,
                  null,
                  true
                )
              : formatCurrency(
                  amortizacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0),
                  null,
                  amortizacionMensual
                )}
          </td>
        </tr>
      </>
    )}

    {/* === EBIT (clickeable) === */}
    <tr
      className={styles.ebitRow}
      onClick={() => setEbitCollapsed(!ebitCollapsed)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCellMargen}>Beneficio Operativo | EBIT {ebitCollapsed ? ">" : ""}</td>
      {meses.map((_, i) => {
        if (i >= monthsToShow) {
          return (
            <td key={i} className="text-end">
              -
            </td>
          );
        }
        // En modo combinado usar valores FIJOS ya en USD
        if (modoCombinado && depreciacionMensualesCombinados) {
          const facturacionMes =
            (publicidadMensualesCombinados[i] || 0) +
            (hardwareMensualesCombinados[i] || 0) +
            (gestionMensualesCombinados[i] || 0) +
            (btlMensualesCombinados[i] || 0);
          const costosVar = costosVariablesMensualesCombinados[i] || 0;
          const costosFijos = costosFijosMensualesCombinados[i] || 0;
          const ebitda = facturacionMes - costosVar - costosFijos;
          const depComb = depreciacionMensualesCombinados[i] || 0;
          const amortComb = (amortizacionMensualesCombinados && amortizacionMensualesCombinados[i]) || 0;
          const ebit = ebitda - depComb - amortComb;
          return (
            <td key={i} className="text-end">
              <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, null, null, true)}</div>
            </td>
          );
        }
        // Modo ventana: usar array pre-computado
        if (verUltimos12Meses) {
          const depW = depreciacionMensual[i] || 0;
          const amortW = amortizacionMensual[i] || 0;
          const ebit = (ebitdaMensualWindowed[i] || 0) - depW - amortW;
          return (
            <td key={i} className="text-end">
              <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, i)}</div>
            </td>
          );
        }
        // Modo normal
        const facturacionMes =
          (valoresMensuales[i] || 0) +
          (ingresosHardwareMensual[i] || 0) +
          (ingresosGestionContenidosMensual[i] || 0) +
          (ingresosBTLMensual[i] || 0);
        const costosFijosMes =
          camposCostosFijos.reduce((sum, campo) => sum + (getCostoFijoValor(campo, i) ?? 0), 0) +
          (i < monthsToShow ? rrhhMensualConBeneficios[i] : 0);
        const ebitda = facturacionMes - totalCostosMes(i) - costosFijosMes;
        const dep = depreciacionMensual[i] || 0;
        const amort = amortizacionMensual[i] || 0;
        const ebit = ebitda - dep - amort;
        return (
          <td key={i} className="text-end">
            <div className={ebit < 0 ? styles.marginNegative : ""}>{formatCurrency(ebit, i)}</div>
          </td>
        );
      })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado && depreciacionMensualesCombinados) {
            const depreciacionYTDComb = depreciacionMensualesCombinados
              .slice(0, monthsToShow)
              .reduce((a, b) => a + b, 0);
            const amortizacionYTDComb = amortizacionMensualesCombinados
              ? amortizacionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
              : 0;
            const totalFact =
              publicidadMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const totalCV = costosVariablesMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const totalCF = costosFijosMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const ebitComb = totalFact - totalCV - totalCF - depreciacionYTDComb - amortizacionYTDComb;
            const pct = totalFact > 0 ? ((ebitComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitComb, null, null, true)} | {pct}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados
          if (verUltimos12Meses) {
            const depYTD = depreciacionMensual.reduce((a, b) => a + b, 0);
            const amortYTD = amortizacionMensual.reduce((a, b) => a + b, 0);
            const ebitdaYTD = ebitdaMensualWindowed.reduce((a, b) => a + b, 0);
            const ebitYTDW = ebitdaYTD - depYTD - amortYTD;
            const ebitMensualW = ebitdaMensualWindowed.map(
              (eb, i) => eb - (depreciacionMensual[i] || 0) - (amortizacionMensual[i] || 0)
            );
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((ebitYTDW / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={ebitYTDW < 0 ? styles.marginNegative : ""}>
                {formatCurrency(ebitYTDW, null, ebitMensualW)} | {pct}
              </div>
            );
          }
          const depreciacionYTD = depreciacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
          const amortizacionYTD = amortizacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
          const ebitYTD = margenFinal - costosFijosYTD - depreciacionYTD - amortizacionYTD;
          // Calcular EBIT mensual para conversión correcta a USD
          const ebitMensual = meses.map((_, i) => {
            if (i >= monthsToShow) return 0;
            const facturacionMes =
              (valoresMensuales[i] || 0) +
              (ingresosHardwareMensual[i] || 0) +
              (ingresosGestionContenidosMensual[i] || 0) +
              (ingresosBTLMensual[i] || 0);
            const costosFijosMes =
              camposCostosFijos.reduce((sum, campo) => sum + (getCostoFijoValor(campo, i) ?? 0), 0) +
              (i < monthsToShow ? rrhhMensualConBeneficios[i] : 0);
            const ebitdaMes = facturacionMes - totalCostosMes(i) - costosFijosMes;
            return ebitdaMes - (depreciacionMensual[i] || 0) - (amortizacionMensual[i] || 0);
          });
          return (
            <div className={ebitYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(ebitYTD, null, ebitMensual)} | {porcentajeSobreFacturacion(ebitYTD)}
            </div>
          );
        })()}
      </td>
    </tr>

    {/* Intereses e Impuestos (colapsables desde Resultado) */}
    {!resultadoCollapsed && (
      <>
        <tr
          onClick={() => interesesMensualesUSD[pais] > 0 && !verChileYPeru && setIsInteresesModalOpen(true)}
          style={{
            cursor: interesesMensualesUSD[pais] > 0 && !verChileYPeru ? "pointer" : "default",
          }}
        >
          <td className={styles.conceptCell}>Intereses</td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            // En modo región: sumar intereses de ambos países (en USD)
            if (verChileYPeru) {
              const totalUSD = interesesMensualesUSD.Chile + interesesMensualesUSD.Perú;
              const formatted = Math.round(totalUSD).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  US$ {formatted}
                </td>
              );
            }
            // País local
            const interesesUSD = interesesMensualesUSD[pais] || 0;
            if (verEnDolares) {
              const formatted = Math.round(interesesUSD).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  US$ {formatted}
                </td>
              );
            }
            // Moneda local
            const rate =
              pais === "Chile" ? dolarMensual[i] || dolarFallback.Chile : dolarMensualPeru[i] || dolarFallback["Perú"];
            const interesesLocal = interesesUSD * rate;
            const formatted = Math.round(interesesLocal).toLocaleString("es-CL");
            return (
              <td key={i} className="text-end">
                {moneda(pais)}
                {formatted}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              // En modo región: sumar intereses de ambos países (en USD)
              if (verChileYPeru) {
                const totalUSD = (interesesMensualesUSD.Chile + interesesMensualesUSD.Perú) * monthsToShow;
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // País local
              const interesesUSD = interesesMensualesUSD[pais] || 0;
              if (verEnDolares) {
                const totalUSD = interesesUSD * monthsToShow;
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // Moneda local
              const rate = pais === "Chile" ? dolarMensual : dolarMensualPeru;
              const totalLocal = meses
                .slice(0, monthsToShow)
                .reduce(
                  (sum, _, i) => sum + interesesUSD * (rate[i] || dolarFallback[pais] || getDolarFallback(pais) || 0),
                  0
                );
              return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
            })()}
          </td>
        </tr>
        <tr>
          <td className={styles.conceptCell}>Impuestos</td>
          {meses.map((_, i) => {
            if (i >= monthsToShow) {
              return (
                <td key={i} className="text-end">
                  -
                </td>
              );
            }
            // En modo región: sumar impuestos de ambos países (en USD)
            if (verChileYPeru) {
              const totalUSD = impuestosMensualesUSD.Chile + impuestosMensualesUSD.Perú;
              const formatted = Math.round(totalUSD).toLocaleString("es-CL");
              return (
                <td key={i} className="text-end">
                  US$ {formatted}
                </td>
              );
            }
            // País local
            const impuestosUSD = impuestosMensualesUSD[pais] || 0;
            if (verEnDolares) {
              return (
                <td key={i} className="text-end">
                  US$ {Math.round(impuestosUSD).toLocaleString("es-CL")}
                </td>
              );
            }
            // Moneda local
            const rate =
              pais === "Chile" ? dolarMensual[i] || dolarFallback.Chile : dolarMensualPeru[i] || dolarFallback["Perú"];
            const impuestosLocal = impuestosUSD * rate;
            return (
              <td key={i} className="text-end">
                {moneda(pais)}
                {Math.round(impuestosLocal).toLocaleString("es-CL")}
              </td>
            );
          })}
          <td className={styles.totalCell}>
            {(() => {
              // En modo región: sumar impuestos de ambos países (en USD)
              if (verChileYPeru) {
                const totalUSD = (impuestosMensualesUSD.Chile + impuestosMensualesUSD.Perú) * monthsToShow;
                return `US$ ${totalUSD.toLocaleString("es-CL")}`;
              }
              // País local
              const impuestosUSD = impuestosMensualesUSD[pais] || 0;
              if (verEnDolares) {
                return `US$ ${(impuestosUSD * monthsToShow).toLocaleString("es-CL")}`;
              }
              // Moneda local
              const rate = pais === "Chile" ? dolarMensual : dolarMensualPeru;
              const totalLocal = meses
                .slice(0, monthsToShow)
                .reduce(
                  (sum, _, i) => sum + impuestosUSD * (rate[i] || dolarFallback[pais] || getDolarFallback(pais) || 0),
                  0
                );
              return `${moneda(pais)}${Math.round(totalLocal).toLocaleString("es-CL")}`;
            })()}
          </td>
        </tr>
      </>
    )}

    {/* === RESULTADO (clickeable) === */}
    <tr
      className={styles.resultadoRow}
      onClick={() => setResultadoCollapsed(!resultadoCollapsed)}
      style={{ cursor: "pointer", userSelect: "none" }}
    >
      <td className={styles.conceptCellMargen}>Beneficio Neto {resultadoCollapsed ? ">" : ""}</td>
      {meses.map((_, i) => {
        if (i >= monthsToShow) {
          return (
            <td key={i} className="text-end">
              -
            </td>
          );
        }
        // En modo combinado usar valores FIJOS ya en USD
        if (modoCombinado && depreciacionMensualesCombinados) {
          const facturacionMes =
            (publicidadMensualesCombinados[i] || 0) +
            (hardwareMensualesCombinados[i] || 0) +
            (gestionMensualesCombinados[i] || 0) +
            (btlMensualesCombinados[i] || 0);
          const costosVar = costosVariablesMensualesCombinados[i] || 0;
          const costosFijos = costosFijosMensualesCombinados[i] || 0;
          const ebitda = facturacionMes - costosVar - costosFijos;
          const depComb = depreciacionMensualesCombinados[i] || 0;
          const amortComb = (amortizacionMensualesCombinados && amortizacionMensualesCombinados[i]) || 0;
          // Intereses + Impuestos de ambos países (ya en USD)
          const interesesComb = interesesMensualesUSD.Chile + interesesMensualesUSD.Perú;
          const impuestosComb = impuestosMensualesUSD.Chile + impuestosMensualesUSD.Perú;
          const resultado = ebitda - depComb - amortComb - interesesComb - impuestosComb;
          return (
            <td key={i} className="text-end">
              <div className={resultado < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultado, null, null, true)}
              </div>
            </td>
          );
        }
        // Modo ventana: usar arrays pre-computados
        if (verUltimos12Meses) {
          const depW2 = depreciacionMensual[i] || 0;
          const amortW2 = amortizacionMensual[i] || 0;
          const ebit = (ebitdaMensualWindowed[i] || 0) - depW2 - amortW2;
          const intUSD = interesesMensualesUSD[pais] || 0;
          const impUSD = impuestosMensualesUSD[pais] || 0;
          const r =
            pais === "Chile" ? dolarMensual[i] || dolarFallback.Chile : dolarMensualPeru[i] || dolarFallback["Perú"];
          const resultado = ebit - intUSD * r - impUSD * r;
          return (
            <td key={i} className="text-end">
              <div className={resultado < 0 ? styles.marginNegative : ""}>{formatCurrency(resultado, i)}</div>
            </td>
          );
        }
        // Modo normal
        const facturacionMes =
          (valoresMensuales[i] || 0) +
          (ingresosHardwareMensual[i] || 0) +
          (ingresosGestionContenidosMensual[i] || 0) +
          (ingresosBTLMensual[i] || 0);
        const costosFijosMes =
          camposCostosFijos.reduce((sum, campo) => sum + (getCostoFijoValor(campo, i) ?? 0), 0) +
          (i < monthsToShow ? rrhhMensualConBeneficios[i] : 0);
        const ebitda = facturacionMes - totalCostosMes(i) - costosFijosMes;
        const ebit = ebitda - (depreciacionMensual[i] || 0) - (amortizacionMensual[i] || 0);
        // Resultado = EBIT - Intereses - Impuestos
        const interesesUSD = interesesMensualesUSD[pais] || 0;
        const impuestosUSD = impuestosMensualesUSD[pais] || 0;
        const rate =
          pais === "Chile" ? dolarMensual[i] || dolarFallback.Chile : dolarMensualPeru[i] || dolarFallback["Perú"];
        const interesesMes = interesesUSD * rate;
        const impuestosMes = impuestosUSD * rate;
        const resultado = ebit - interesesMes - impuestosMes;
        return (
          <td key={i} className="text-end">
            <div className={resultado < 0 ? styles.marginNegative : ""}>{formatCurrency(resultado, i)}</div>
          </td>
        );
      })}
      <td className={styles.totalCell}>
        {(() => {
          if (modoCombinado && depreciacionMensualesCombinados) {
            const depreciacionYTDComb = depreciacionMensualesCombinados
              .slice(0, monthsToShow)
              .reduce((a, b) => a + b, 0);
            const amortizacionYTDComb = amortizacionMensualesCombinados
              ? amortizacionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0)
              : 0;
            const totalFact =
              publicidadMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              hardwareMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              gestionMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0) +
              btlMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const totalCV = costosVariablesMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            const totalCF = costosFijosMensualesCombinados.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
            // Intereses + Impuestos de ambos países (ya en USD)
            const interesesTotalUSD = interesesMensualesUSD.Chile + interesesMensualesUSD.Perú;
            const impuestosTotalUSD = impuestosMensualesUSD.Chile + impuestosMensualesUSD.Perú;
            const interesesYTDComb = interesesTotalUSD * monthsToShow;
            const impuestosYTDComb = impuestosTotalUSD * monthsToShow;
            const resultadoComb =
              totalFact -
              totalCV -
              totalCF -
              depreciacionYTDComb -
              amortizacionYTDComb -
              interesesYTDComb -
              impuestosYTDComb;
            const pct = totalFact > 0 ? ((resultadoComb / totalFact) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={resultadoComb < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoComb, null, null, true)} | {pct}
              </div>
            );
          }
          // Modo ventana: usar arrays pre-computados
          if (verUltimos12Meses) {
            const intUSD = interesesMensualesUSD[pais] || 0;
            const impUSD = impuestosMensualesUSD[pais] || 0;
            const rArr = pais === "Chile" ? dolarMensual : dolarMensualPeru;
            const fb = dolarFallback[pais] || getDolarFallback(pais) || 0;
            const resultadoMensualW = ebitdaMensualWindowed.map((eb, i) => {
              const ebit = eb - (depreciacionMensual[i] || 0) - (amortizacionMensual[i] || 0);
              return ebit - intUSD * (rArr[i] || fb) - impUSD * (rArr[i] || fb);
            });
            const resultadoYTDW = resultadoMensualW.reduce((a, b) => a + b, 0);
            const factYTD = facturacionMensualWindowed.reduce((a, b) => a + b, 0);
            const pct = factYTD > 0 ? ((resultadoYTDW / factYTD) * 100).toFixed(1) + "%" : "0%";
            return (
              <div className={resultadoYTDW < 0 ? styles.marginNegative : ""}>
                {formatCurrency(resultadoYTDW, null, resultadoMensualW)} | {pct}
              </div>
            );
          }
          const depreciacionYTD = depreciacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
          const amortizacionYTD = amortizacionMensual.slice(0, monthsToShow).reduce((a, b) => a + b, 0);
          // Calcular intereses e impuestos YTD (convertidos a moneda local por mes)
          const interesesUSD = interesesMensualesUSD[pais] || 0;
          const impuestosUSD = impuestosMensualesUSD[pais] || 0;
          const rateArr = pais === "Chile" ? dolarMensual : dolarMensualPeru;
          const fallbackRate = dolarFallback[pais] || getDolarFallback(pais) || 0;
          const interesesYTD = meses
            .slice(0, monthsToShow)
            .reduce((sum, _, i) => sum + interesesUSD * (rateArr[i] || fallbackRate), 0);
          const impuestosYTD = meses
            .slice(0, monthsToShow)
            .reduce((sum, _, i) => sum + impuestosUSD * (rateArr[i] || fallbackRate), 0);
          const resultadoYTD =
            margenFinal - costosFijosYTD - depreciacionYTD - amortizacionYTD - interesesYTD - impuestosYTD;
          // Calcular Resultado mensual para conversión correcta a USD
          const resultadoMensual = meses.map((_, i) => {
            if (i >= monthsToShow) return 0;
            const facturacionMes =
              (valoresMensuales[i] || 0) +
              (ingresosHardwareMensual[i] || 0) +
              (ingresosGestionContenidosMensual[i] || 0) +
              (ingresosBTLMensual[i] || 0);
            const costosFijosMes =
              camposCostosFijos.reduce((sum, campo) => sum + (getCostoFijoValor(campo, i) ?? 0), 0) +
              (i < monthsToShow ? rrhhMensualConBeneficios[i] : 0);
            const ebitdaMes = facturacionMes - totalCostosMes(i) - costosFijosMes;
            const interesesMes = interesesUSD * (rateArr[i] || fallbackRate);
            const impuestosMes = impuestosUSD * (rateArr[i] || fallbackRate);
            return (
              ebitdaMes - (depreciacionMensual[i] || 0) - (amortizacionMensual[i] || 0) - interesesMes - impuestosMes
            );
          });
          return (
            <div className={resultadoYTD < 0 ? styles.marginNegative : ""}>
              {formatCurrency(resultadoYTD, null, resultadoMensual)} | {porcentajeSobreFacturacion(resultadoYTD)}
            </div>
          );
        })()}
      </td>
    </tr>
  </>
);
